/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RecommendationDto } from '../models';
/**
 * RecommendationsApi - axios parameter creator
 * @export
 */
export const RecommendationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerGetRecommendations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationComplete: async (recommendationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationId' is not null or undefined
            assertParamExists('recommendationsControllerSetRecommendationComplete', 'recommendationId', recommendationId)
            const localVarPath = `/api/recommendations/{recommendationId}/complete`
                .replace(`{${"recommendationId"}}`, encodeURIComponent(String(recommendationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationImInterested: async (recommendationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationId' is not null or undefined
            assertParamExists('recommendationsControllerSetRecommendationImInterested', 'recommendationId', recommendationId)
            const localVarPath = `/api/recommendations/{recommendationId}/im-interested`
                .replace(`{${"recommendationId"}}`, encodeURIComponent(String(recommendationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationNotRelevant: async (recommendationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationId' is not null or undefined
            assertParamExists('recommendationsControllerSetRecommendationNotRelevant', 'recommendationId', recommendationId)
            const localVarPath = `/api/recommendations/{recommendationId}/not-relevant`
                .replace(`{${"recommendationId"}}`, encodeURIComponent(String(recommendationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerUpdateCompanyRecommendations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/recommendations/update-company-recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecommendationsApi - functional programming interface
 * @export
 */
export const RecommendationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecommendationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationsControllerGetRecommendations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecommendationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationsControllerGetRecommendations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.recommendationsControllerGetRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationsControllerSetRecommendationComplete(recommendationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationsControllerSetRecommendationComplete(recommendationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.recommendationsControllerSetRecommendationComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationsControllerSetRecommendationImInterested(recommendationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationsControllerSetRecommendationImInterested(recommendationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.recommendationsControllerSetRecommendationImInterested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationsControllerSetRecommendationNotRelevant(recommendationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationsControllerSetRecommendationNotRelevant(recommendationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.recommendationsControllerSetRecommendationNotRelevant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendationsControllerUpdateCompanyRecommendations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationsControllerUpdateCompanyRecommendations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecommendationsApi.recommendationsControllerUpdateCompanyRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecommendationsApi - factory interface
 * @export
 */
export const RecommendationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecommendationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerGetRecommendations(options?: RawAxiosRequestConfig): AxiosPromise<Array<RecommendationDto>> {
            return localVarFp.recommendationsControllerGetRecommendations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationComplete(recommendationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendationsControllerSetRecommendationComplete(recommendationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationImInterested(recommendationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendationsControllerSetRecommendationImInterested(recommendationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} recommendationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerSetRecommendationNotRelevant(recommendationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendationsControllerSetRecommendationNotRelevant(recommendationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendationsControllerUpdateCompanyRecommendations(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendationsControllerUpdateCompanyRecommendations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecommendationsApi - object-oriented interface
 * @export
 * @class RecommendationsApi
 * @extends {BaseAPI}
 */
export class RecommendationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendationsControllerGetRecommendations(options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).recommendationsControllerGetRecommendations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} recommendationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendationsControllerSetRecommendationComplete(recommendationId: number, options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).recommendationsControllerSetRecommendationComplete(recommendationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} recommendationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendationsControllerSetRecommendationImInterested(recommendationId: number, options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).recommendationsControllerSetRecommendationImInterested(recommendationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} recommendationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendationsControllerSetRecommendationNotRelevant(recommendationId: number, options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).recommendationsControllerSetRecommendationNotRelevant(recommendationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecommendationsApi
     */
    public recommendationsControllerUpdateCompanyRecommendations(options?: RawAxiosRequestConfig) {
        return RecommendationsApiFp(this.configuration).recommendationsControllerUpdateCompanyRecommendations(options).then((request) => request(this.axios, this.basePath));
    }
}

